import { useEffect, useRef } from 'react'
import { useDebauncedCallback } from '../../../hooks/useDebauncedCallback'
import { publishContentSize } from '../parentFrameEvents'
import { usePublishFrameEvent } from '../ParentFrameProvider'

export const useContentSizeListner = (): void => {
    const publisher = usePublishFrameEvent()
    const elRef = useRef(document.body)

    const debounced = useDebauncedCallback((entry: ResizeObserverEntry) => {
        publisher(publishContentSize({ height: entry.target.scrollHeight }))
    }, 100)

    const observer = useRef(
        new ResizeObserver(entries => {
            debounced(entries[0])
        })
    )

    useEffect(() => {
        const observeCurrent = observer.current
        const elCurrent = elRef.current
        if (elCurrent) {
            observeCurrent.observe(elCurrent)
        }

        return () => {
            observeCurrent.unobserve(elCurrent)
        }
    }, [elRef, observer])
}
